import React, { Component } from 'react';
import './Cart.css';
import ENV from '../../environments/environment'


class Cart extends Component {

  constructor(props) {
    super(props)
    this.state = {
      products: [],
      selectedProducts:[],
      error: '',
      checked: true,
      loading: true,
      total: 0,
      step: 1,
      auth: false,
      loadingStep: false,
      minProducts: true,
      selectedProduct: [],
      search: '',
      searchProducts: []
    }
    this.closeCart = this.closeCart.bind(this)
    this.changeProductUnits = this.changeProductUnits.bind(this);
    this.verifyProductUnits = this.verifyProductUnits.bind(this)
  }

  componentDidMount() {
   let products = JSON.parse(localStorage.getItem('products'))
   this.setState({
     products
   })
  }

  changeProductUnits(action , product) {
    let total;
    let original_price
    if(product.original_price) {
      original_price = product.original_price
    } else {
      original_price = product.price
    }
    if(action === 'sum') {
     product.units++;
     if(product.units < 1) {
       total = this.state.total + product.price;
     } else {
       total = this.state.total + parseInt(original_price);
     }
     this.setState({
       total
     })
    } else {
      if(product.units > 0) {
        product.units--;
        if(product.units < 1) {
          total = this.state.total - product.price;
        } else {
          total = this.state.total - parseInt(original_price);
        }
        this.setState({
          total
        })
      }
    }
    if(product.units < 1) {
      product.total_price = 0
    } else {
      product.total_price = 1 * product.price + ( (product.units - 1) * original_price )
    }
    this.verifyProductUnits()
  }

  verifyProductUnits() {
    let units = 0;
    let minProducts
    for(let product of this.state.products) {
      units = units + product.units
    }
    if(units > 0) {
      minProducts = true;
    } else {
      minProducts = false;
    }
    this.setState({
      minProducts
    })
  }

  closeCart() {
    let products = this.state.products
    let selectedProducts = []
    for(let product of this.state.products) {
      if(product.units) {
        selectedProducts.push(product)
      }
    }
    localStorage.setItem('products', JSON.stringify(selectedProducts))
    this.props.cart(false)
  }

  render() {
    let products = [];
    let loadingProducts = [];
    let cont = 0;
    let original_price;
    let original = false;
    let product_image ;
    for(let product of this.state.products) {
      cont++
      if(product.original_price) {
        original_price = product.original_price;
        original = true;
      } else {
        original_price = product.price
      }
      if(!product.total_price) {
         product.total_price = product.price
      }
      if(!product.units && product.units !== 0) {
         product.units = 1
      }
      products.push(

        <li className="collection-item avatar" key={cont}>
          <img onClick={() => this.selectProduct(product)} src={product.image} alt="" className="circle"/>
          <span onClick={() => this.selectProduct(product)} className="title prod truncate">{product.name}</span>
            { original &&   <p> {( parseInt(original_price) !== product.price ) && <span> ${product.original_price}</span> } ${product.total_price}
               </p> }
           {!original && <p> ${product.total_price}</p>  }
           <a className="secondary-content qty">
             <span onClick={() => this.changeProductUnits('less', product)}>  - </span>
             <span> {product.units} </span>
             <span onClick={() => this.changeProductUnits('sum', product)}>+ </span>
          </a>
        </li>


      )
    }

    return (
      <div>
    <header>
      <nav>
       <div className="nav-wrapper no-color">
         <a  className="brand-logo center">Canasta</a>
         <a onClick={this.closeCart} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
       </div>
      </nav>
    </header>
    <ul className="collection">
    {products}
    </ul>
    </div>
    );
  }
}


export default Cart;



// WEBPACK FOOTER //
// ./src/components/cart/Cart.js